import {SegmentWrapper} from './segment-wrapper.styled'

import type {JSX} from 'react'

interface SegmentProps {
    segmentSize: number
    color: string
    animationDuration: string
}

export function Segment({segmentSize, color, animationDuration}: SegmentProps): JSX.Element {
    const segmentRadius = segmentSize * 0.95
    const remainder = segmentSize - segmentRadius

    return (
        <SegmentWrapper size={segmentSize} animationDuration={animationDuration}>
            <div
                style={{
                    background: color,
                    transform: 'rotate(0deg)',
                    position: 'absolute',
                    // TODO: Fix this the next time the file is edited.
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    left: `${remainder}px`,
                    // TODO: Fix this the next time the file is edited.
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    top: `${remainder}px`,
                    // TODO: Fix this the next time the file is edited.
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    width: `${segmentRadius}px`,
                    // TODO: Fix this the next time the file is edited.
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    height: `${segmentRadius}px`,
                    // TODO: Fix this the next time the file is edited.
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    borderRadius: `${segmentRadius}px 0 0 0`,
                    // TODO: Fix this the next time the file is edited.
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    transformOrigin: `${segmentSize}px ${segmentSize}px`,
                }}
            />
        </SegmentWrapper>
    )
}
